exports.timeConvert = (timestamp,num) => {//num:0 MM-DD hh:mm  num:1  YYYY-MM-DD hh:mm:ss // timestamp:时间戳 
  // timestamp = timestamp + ' '
 let y = timestamp.substring(0,4)
 let m = timestamp.substring(4,6)
 let d = timestamp.substring(6,8)
 let h = timestamp.substring(8,10)
 let minute = timestamp.substring(10,12)
 let second = timestamp.substring(12,14)
  if(num==0){
      return m + '-' + d +' '+ h +':'+ minute;  
  }else{
      return y + '-' + m + '-' + d +' '+ h +':'+ minute +':' + second;  
  }
}
/**
 * 防抖操作
 * TOOL.throttle(FUNCTION, 5000);
 * @param {*} fn   Function
 * @param {*} wait  Number
*/
exports.throttle = (fn, wait = 1000) => {
  var timer;
  return function (...args) {
    if (!timer) {
      timer = setTimeout(() => timer = null, wait);
      return fn.apply(this, args);
    }
  }
}
//获取url / 最后一个值
exports.getVal = (data) => {
  return data.substring(data.lastIndexOf("/")+1,data.length)
}
/**
 *  Function 时间戳转时间
 * @param {*} timestamp  时间戳10位或者13位  String or Number
 * @param {*} template  输出模板
 */
 const toDate = (timestamp, template = '{1}-{2} {3}:{4}') => {
  // 补全13位
  timestamp = (timestamp + Array(13).join(0)).substring(0, 13);
  //  转换数字类型
  timestamp = Number(timestamp);
  //  转换时间格式
  timestamp = new Date(timestamp + 8 * 60 * 60 * 1000).toJSON();
  //  时间转换数组
  timestamp = timestamp.match(/\d+/g);
  // 遍历数组转换模板
  return template.replace(/\{(\d+)\}/g, (_, n) => {
    let item = timestamp[n] || '0';
    item.length < 2 ? item = '0' + item : null;
    return item;
  });
}
exports.toDateList = (str, template = '{1}-{2} {3}:{4}') => {
  let timer = "";
  if (str) {
    timer = toDate(str,template);
  }
  return timer;
}
// 字符高亮
exports.letterLight = (letterLight, letter) => {
  letter = letter.replace(/[.*+?^${}()|[\]\\{}/]/g, '\\$&');
  return letterLight.replace(eval(`/${letter}/ig`), _ => {
    return `<font style='color:#0077FF;'>${_}</font>`;
  });
} 
// 判断是否包含特殊字符
exports.includeTest = (query) => {
  var flag = new RegExp("[%\\\\]");
  return flag.test(query)
} 